const paths = {
  main: '/',
};

export default paths;
